import { Category, EntityTypes, JobOrder, ToManyRef } from "@bullhorn/bullhorn-types";
import { AppBridge, AppBridgeService, Helpers, IDataTableFilter, RemoteDataTableService } from "novo-elements";
import { Observable, from, of } from "rxjs";
import { Where } from '@bullhorn/taurus';
import { HttpService } from "./http.service";
import { ActivatedRoute } from "@angular/router";

export class JobOrderRemoteDataTableService extends RemoteDataTableService<JobOrder> {
  public url: string;
  public additionalFilters: any = {};
  public jobCategories: Category[] = [];
  public candidateIds: number[] = [];

  constructor(private httpService: HttpService, private route: ActivatedRoute) {
    super();
  }

  public getTableResults(
    sort: { id: string; value: string; transform?: Function },
    filter: IDataTableFilter | IDataTableFilter[],
    page: number,
    pageSize: number,
    globalSearch?: string,
  ): Observable<{ results: JobOrder[]; total: number }> {
    const whereQuery: string = this.buildWhereClause(filter);
    const sortQuery: string = this.buildSortColumn(sort);
    const pageQuery: number = this.buildStart(page, pageSize);
    return from(this.getData(whereQuery, pageSize, sortQuery, pageQuery, filter));
    
  }

  private async getData(whereQuery, pageSize, sortQuery, pageQuery, filter): Promise<{ results: JobOrder[]; total: number }> {
    if (!Object.keys(this.additionalFilters).length) {
      const res = await this.httpService.getEntity(EntityTypes.JobOrder, this.route.snapshot.queryParamMap.get('EntityID') as any || 1, 'customText6,yearsRequired,title,id,categories,submissions[500](candidate)');
      console.log(res);
      const jobOrder: JobOrder = res.data;
      const minYears = parseInt(jobOrder.customText6 as string || '0');
      const maxYears = jobOrder.yearsRequired || 0;
      const minYearsArray: any = [];
      const maxYearsArray: any = [];
      // fill minYearsArray with values from minYears to 50
      for (let i = Math.max(minYears - 1, 0); i <= 50; i++) {
        minYearsArray.push(i.toString());
      }

      // fill maxYearsArray with values from maxYears to 50
      for (let i = Math.min(maxYears + 1, 50); i >= 0; i--) {
        maxYearsArray.push(i);
      }
      console.log((jobOrder.categories as ToManyRef<Category>)?.data.map((category: any) => category.id));
      this.additionalFilters = { customText6: minYearsArray, yearsRequired: maxYearsArray, ['categories.id']:  (jobOrder.categories as ToManyRef<Category>)?.data.map((category: any) => category.id), id: {not: jobOrder.id}};
      this.jobCategories = (jobOrder.categories as ToManyRef<Category>)?.data;
      whereQuery = this.buildWhereClause(filter);
      const submissions = jobOrder.submissions as ToManyRef<any>;
      this.candidateIds = submissions?.data.map((submission: any) => submission.candidate.id);
    }

    const candidateIdFilterText = this.candidateIds.length ? `AND NOT candidate.id IN (${this.candidateIds.join(',')})` : '';
    const response = await this.httpService.search(EntityTypes.JobOrder, whereQuery, 'id,yearsRequired,customText6,categories,dateAdded,title,owner(name),clientCorporation(id,name),clientContact(id,name),employmentType,isOpen,status,payRate,clientBillRate,salary,feeArrangement,submissions[500](id,candidate(status,name,owner(name)),status){(candidate.status=\'Active\' OR candidate.status=\'Active - NoCo\') AND status IN (\'Client Submitted\',\'Bite\',\'Interview\',\'2nd Interview\',\'3rd Interview\') ' + candidateIdFilterText + '}', 'full', pageSize, sortQuery, pageQuery);

    console.log('response', response);

    //filter out jobs that dont have candidates
    const newData = response.data.filter((job: any) => job.submissions.data.length);
    const newTotal  =  response.data.length - newData.length;

    return { results: newData, total: response.total - newTotal };
  }

  private buildWhereClause(filter: IDataTableFilter | IDataTableFilter[]): string {
    const query: any = {};
    if (filter) {
      const filters = Helpers.convertToArray(filter);
      filters.forEach((aFilter) => {
        query[aFilter.id] = aFilter.transform ? aFilter.transform(aFilter.value) : aFilter.value;
      });
    }

    console.log(this.additionalFilters);
    return (
      {
        ...query, 
        status: {not: 'Archive'}, 
        isOpen: true,
        ['submissions.id']: {min: 0, max: 9999999}, 
        submissions: {
          status: ['Client Submitted', 'Bite', 'Interview', '2nd Interview', '3rd Interview'],
        }, isDeleted: false, ...this.additionalFilters
      });
  }

  private buildSortColumn(sort: { id: string; value: string; transform?: Function }): string {
    if (sort) {
      let value = sort.id;
      if (sort.transform) {
        value = sort.transform(value);
      }
      return sort.value === 'asc' ? value : `-${value}`;
    }
    return '';
  }

  private buildStart(page: number, pageSize: number): number {
    return (page || 0) * pageSize;
  }

}